import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map, shareReplay} from 'rxjs/operators';
import * as Countries from '../../../../assets/data/countries.json';
import { InternationalPrefixEnum } from 'src/app/utils/internationalPrefix.enum';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  constructor() { }

  getFormattedCountries(): Observable<any[]> {
    return this.getCountries().pipe(
      map(e => e ? Object.values(e).map((c: any) => {
        if (c.italian_country_name_1) {
          return {label:c.italian_country_name_1, id: c.iso3361_2_characters, value: c.iso3361_3_characters, prefix: InternationalPrefixEnum[c.iso3361_2_characters?.toLowerCase()] || ''};
        } else if (c.italian_country_name_2) {
          return {label:c.italian_country_name_2, id: c.iso3361_2_characters, value: c.iso3361_3_characters, prefix: InternationalPrefixEnum[c.iso3361_2_characters?.toLowerCase()] || ''};
        }
        return c.english_country_name;
      }).filter(x => x) : undefined),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getCountries(): Observable<any> {
    return of(Countries).pipe(
      map((e: any) => e.default),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
